import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M961.740749,682.84963 L1493.46468,1214.46062 L1333.65385,1374.1585 L1074.7942,1115.18591 L1074.7942,1920 L848.800236,1920 L848.800236,1115.18591 L589.940583,1374.1585 L430.129758,1214.46062 L961.740749,682.84963 Z M1750.16717,338.708596 L1750.16717,564.702561 L169,564.702561 L169,338.708596 L1750.16717,338.708596 Z M1750.16717,0 L1750.16717,225.881024 L169,225.881024 L169,0 L1750.16717,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "matrix(1 0 0 -1 0 1920)"
});

var IconPageDownSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPageDownSolid, _Component);

  var _super = _createSuper(IconPageDownSolid);

  function IconPageDownSolid() {
    _classCallCheck(this, IconPageDownSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPageDownSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPageDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPageDownSolid.displayName = "IconPageDownSolid";
  return IconPageDownSolid;
}(Component);

IconPageDownSolid.glyphName = 'page-down';
IconPageDownSolid.variant = 'Solid';
IconPageDownSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPageDownSolid;
export { IconPageDownSolid };